<template> 
	<div class="w-full body-bg">
		<div class="h-img-block"><img class="h-img" src="../assets/2.png" /></div>
		<div v-if="!isShow" class="login">
			<div class="login-form">
				<div class="login-form_title">忘记密码</div>
				<div>
					<label class="login-form-lable">手机号</label>
					<input class="login-form_item" name="tel" placeholder="请输入手机号码" type="number" v-model="tel" />
				</div>

				<div v-if="wTel" class="font-wraing">
					<img class="wraing-icon" src="../assets/3.png" /><span>{{ wTel }}
					</span>
				</div>
				<div>
					<label class="login-form-lable">密码</label>
					<input class="login-form_item" name="paw" placeholder="请输入9~16位密码" type="password" v-model="paw" />
				</div>
				<div v-if="wPaw" class="font-wraing">
					<img class="wraing-icon" src="../assets/3.png" /><span>{{
       wPaw
     }}</span>
				</div>
				<div>
					<label class="login-form-lable">确认密码</label>
					<input class="login-form_item" name="newPaw" placeholder="请输入确认密码" type="password"
						v-model="newPaw" />
				</div>

				<div v-if="wNewPaw" class="font-wraing">
					<img class="wraing-icon" src="../assets/3.png" /><span>{{
       wNewPaw
     }}</span>
				</div>

				<div class="pos-input">
					<div class="">
						<span class="login-form-lable">短信验证</span>
						<input class="login-form_item" name="code" type="number" placeholder="请输入短信验证码"
							v-model="code" />
					</div>
					<div v-show="show" @click="getCode" class="code-block">发送验证码</div>
					<div v-show="!show" class="code-block">{{count}} s</div>
				</div>
				<div v-if="wCode" class="font-wraing">
					<img class="wraing-icon" src="../assets/3.png" /><span>{{
       wCode
     }}</span>
				</div>

				<button class="login-but" @click="login">提交</button>
				<button class="login-clear" @click="clear">取消</button>

			</div>
		</div>
		<ForgetHit v-if="isShow" />
	</div>
</template>

<script>
	import ForgetHit from "../components/ForgetHit"
	import {
		IsPaw,
		IsCode,
		IsPawCompare,
		IsTel,
	} from "../utils/validate";
	import {
		ForgetPassword,
		SendForgetSms,
	} from "../utils/api.js"
	export default {
		name: "Login",
		components: {
			ForgetHit
		},
		data() {
			return {
				isShow: false,

				paw: "",
				wPaw: "", //密码提示
				code: "",
				wCode: "", //验证码提示
				newPaw: "",
				wNewPaw: "", //确认密码

				tel: "",
				wTel: "", //手机号码
				pawRemember: false, //是否记住密码
				// 验证码
				show: true,
				count: '',
				timer: null,
			};
		},

		methods: {
			// 发送验证码
			getCode() {
				const TIME_COUNT = 60;
				const data = {
					phone: this.tel
				}
				if (IsTel(this, this.tel, "手机号码")) {
					SendForgetSms(data).then(res => {
						console.log(res)
						if (!this.timer) {
							this.count = TIME_COUNT;
							this.show = false;
							this.timer = setInterval(() => {
								if (this.count > 0 && this.count <= TIME_COUNT) {
									this.count--;
								} else {
									this.show = true;
									clearInterval(this.timer);
									this.timer = null;
								}
							}, 1000)
						}
					}).catch(err => {
						this.$message.error(err);
					})
				}


			},
			login() {
				if (
					IsTel(this, this.tel, "手机号码") &&
					IsPaw(this, this.paw, "登录密码") &&
					IsPawCompare(this, this.newPaw, "确认密码", this.paw) &&
					IsCode(this, this.code, "验证码")
				) {
					console.log("校验通过");
					const data = {
						"password": this.paw,
						"phone": this.tel,

						"code": this.code
					}
					ForgetPassword(data).then(res => {
						console.log(res)
						this.$message({
							message: '设置成功',
							type: 'success'
						});
						this.isShow = true

					}).catch(err => {
						this.$message.error(err);
					})
				}
			},
			clear(){
				this.$router.push({
					path: "/"
				});
			},
			onRegisterTap() {
				this.$router.push({
					path: "/register"
				});
			},
		},
	};
</script>
<style lang="less" scoped>
	#app {
		width: 100%;
		height: 100%;
	}

	body {
		width: 100%;
		height: 100%;
	}

	.w-full {
		width: 100%;
		height: 100%;
	}

	.body-bg {
		background: url("../assets/1.png");
		background-size: cover;
		background-repeat: no-repeat;
		overflow: hidden;
		height: 100%;

		.h-img-block {
			margin-top: 59px;
			text-align: center;

			.h-img {
				margin: 0 auto;
			}
		}

		.login {
			margin-top: 43px;

			.login-form {
				width: 658px;
				//  height: 473px;
				background: #fff;
				margin: 0 auto;
				padding: 20px 20px 40px 22px;

				.login-form-lable {
					display: inline-block;
					width: 70px;
					color: #757575;
					font-size: 14px;
					text-align: right;
				}

				&_title {
					color: #272f3c;
					font-size: 24px;
					font-weight: bold;
					line-height: 26px;
					text-align: left;
					border-bottom: 1px solid #dbdbdb;
					padding-bottom: 18px;
				}

				&_item {
					width: 280px;
					height: 42px;
					border: 1px solid #bdc3cb;
					padding: 0px 11px;
					font-size: 14px;
					margin-left: 12px;
					margin-top: 10px;
				}

				.margin-top-29 {
					margin-top: 29px;
				}

				.pos-input {
					position: relative;

					.margin-top-0 {
						margin-top: 0px;
					}

					.code-block {
						position: absolute;
						top: 10px;
						right: 136px;
						width: 102px;
						height: 42px;
						text-align: center;
						line-height: 42px;
						color: #194abe;
						border: 1px solid #194abe;
						font-size: 14px;
						cursor: pointer;
					}
				}

				.login-form_assist {
					width: 280px;
					//   height: 60px;
					//  line-height: 60px;
					margin-top: 15px;
					// margin-left: 32px;
					margin-bottom: 19px;
					vertical-align: middle;

					&_isAgree {
						display: inline-block;

						margin-right: 8px;
					}

					&_isAgree:checked::after {
						background: crimson;
					}

					a {
						float: right;
						text-decoration: underline;
						color: #71767c;
						font-size: 14px;
					}
				}

				.login-but {
					width: 302px;
					height: 48px;
					background: #194abe;
					opacity: 1;
					border-radius: 6px;
					// margin-left: 32px;
					color: #fff;
					font-size: 16px;
					font-weight: bold;
					border: none;
					cursor: pointer;

					margin-left: 80px;
					margin-top: 31px;
				}

				.login-clear {
					width: 302px;
					height: 48px;
					background: #fff;
					opacity: 1;
					border-radius: 6px;
					// margin-left: 32px;
					color: #7c828a;
					font-size: 16px;
					font-weight: bold;
					border: none;
					cursor: pointer;
					border: 1px solid #7c828a;
					margin-left: 80px;
					margin-top: 14px;
				}

				.login-register {
					width: 280px;
					height: 48px;
					background: #ffffff;
					opacity: 1;
					border-radius: 6px;
					// margin-left: 32px;
					color: #194abe;
					font-size: 16px;
					font-weight: bold;
					margin-top: 24px;
					text-align: center;
					line-height: 48px;
					border: 1px solid #194abe;
					cursor: pointer;
					border-radius: 6px;
				}

				.font-wraing {
					color: #ff7476;
					font-size: 14px;
					margin-left: 220px;
					margin-top: 6px;
					text-align: left;
				}

				.wraing-icon {
					display: inline-block;
					margin-right: 10px;
				}
			}
		}
	}
</style>
